import React from "react";
import { FiFileText } from "react-icons/fi";
import "../../styles/support-chat-parts.css";

export const readSupportAttachment = (file) =>
  new Promise((resolve, reject) => {
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/webp",
      "application/pdf",
    ];
    if (!allowedTypes.includes(file.type)) {
      reject(new Error("Choose a JPG, PNG, WebP, or PDF file."));
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      reject(new Error("Attachments must be 2 MB or smaller."));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result || "");
      const data = result.split(",")[1];
      if (!data) {
        reject(new Error("Could not read this attachment."));
        return;
      }
      resolve({
        name: file.name,
        type: file.type,
        size: file.size,
        data,
      });
    };
    reader.onerror = () => reject(new Error("Could not read this attachment."));
    reader.readAsDataURL(file);
  });

export const SupportAvatar = ({ emoji = "🧑‍💼", className = "" }) => (
  <span className={`support-chat-avatar ${className}`} aria-hidden="true">
    {emoji}
  </span>
);

export const SupportAttachmentPreview = ({ attachment }) => {
  if (!attachment) return null;
  const dataUrl = `data:${attachment.type};base64,${attachment.data}`;
  return (
    <div className="support-chat-attachment">
      {attachment.type.startsWith("image/") ? (
        <a href={dataUrl} target="_blank" rel="noreferrer" aria-label={attachment.name}>
          <img src={dataUrl} alt={attachment.name} />
        </a>
      ) : (
        <a href={dataUrl} download={attachment.name}>
          <FiFileText />
          <span>{attachment.name}</span>
        </a>
      )}
      <small>{attachment.name}</small>
    </div>
  );
};
